import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { concatWithDot } from 'helpers/string';

import { EXECUTIVE_SUMMARY_RISKS_NAMES, prefix } from './utils/form';

export const RisksExecSummary: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_EXECUTIVE_SUMMARY.RISKS,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('executiveSummary.title')}
          badgeText={t('executiveSummary.risks.title')}
          section={FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.risks.mainRisks')}
        aiFieldName={concatWithDot(prefix, EXECUTIVE_SUMMARY_RISKS_NAMES.MAIN_RISKS)}
      >
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.risks.mainRisks"
          name={concatWithDot(prefix, EXECUTIVE_SUMMARY_RISKS_NAMES.MAIN_RISKS)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.risks.measures')}
        aiFieldName={concatWithDot(prefix, EXECUTIVE_SUMMARY_RISKS_NAMES.MEASURES)}
      >
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.risks.measures"
          name={concatWithDot(prefix, EXECUTIVE_SUMMARY_RISKS_NAMES.MEASURES)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
    </>
  );
};
